const AppDecorate = require('../app/decorate');
const RestrictionsDecorate = require('../facade/restrictions/decorate');
const eventName = INKIVE.C.IS_MOBILE ? 'advice.event_name.tap' : 'advice.event_name.click';
import toastr from 'toastr';

function Advice () {
  this.shown = [];
}

Advice.prototype = _.extend({
  messages: [
    { id: 'save-first', type: 'info' },
    { id: 'workflow-request-wip', type: 'warning' },
    { id: 'imported-results', type: 'warning' },
    { id: 'share-error', type: 'error' },
    { id: 'add-to-library-error', type: 'error' },
    { id: 'add-to-library-duplicity', type: 'warning' },
    { id: 'add-to-library-success', type: 'success' },
    { id: 'upload-error', type: 'error' },
    { id: 'image-processing-error', type: 'info' },
    { id: 'low-resolution', type: 'warning' },
    { id: 'pick-template', type: 'info' },
    { id: 'template-back', type: 'info' },
    { id: 'upload-cancel', type: 'info' },
    { id: 'project-name', type: 'warning' },
    { id: 'share-success', type: 'success' },
    { id: 'already-saved', type: 'success' },
    { id: 'thumb-not-load', type: 'warning' },
    { id: 'image-replacement-selection', type: 'error' },
    { id: 'restriction-logo-replace', type: 'error' },
    { id: 'restriction-icon-replace', type: 'error' },
    { id: 'nothing-to-save', type: 'success' },
    { id: 'crop', type: 'warning', once: true },
    { id: 'pdf-text', type: 'warning', once: true },
    { id: 'convert-to-layout-box', type: 'success' },
    { id: 'crop-restriction-applied', type: 'success' },
    { id: 'color-restriction-applied', type: 'warning' },
    { id: 'source-restriction-applied', type: 'warning' },
    { id: 'dropbox-view', type: 'warning', once: true },
    { id: 'long-time-no-save', type: 'warning' },
    { id: 'clipper-rotation-limit', type: 'info' },
    { id: 'spacing-and-underline', type: 'warning' },
    { id: 'uploading-images-save', type: 'warning' },
    { id: 'undo-unlocked-layout-image', type: 'info' },
    { id: 'add-item-to-library', type: 'success' },
    { id: 'error-adding-item-to-library', type: 'error' },
    { id: 'image-flip-disabled', type: 'error' },
    { id: 'choose-restriction-option', type: 'warning' },
    { id: 'group-template', type: 'warning' },
    { id: 'resize-text-adjust-to-box', type: 'info', once: true },
    { id: 'empty-clipboard-on-paste', type: 'warning' },
    { id: 're-order-pages-error', type: 'error' },
    { id: 'background-color-add', type: 'info' },
    { id: 'img-quality-acceptable', type: 'info' },
    { id: 'low-img-quality-present', type: 'warning' },
    { id: 'file-not-allowed', type: 'error' },
    { id: 'uploading-file', type: 'warning' },
    { id: 'global-locked', type: 'error' },
    { id: 'translation-copied', type: 'info' },
    { id: 'processing-pdf', type: 'info' },
    { id: 'pdf-ready', type: 'success' },
    { id: 'generating-table-of-contents', type: 'info' },
    { id: 'table-of-contents-ready', type: 'success' },
    { id: 'video-download-error', type: 'error' },
    { id: 'pdf-download-error', type: 'error' },
    { id: 'display-parent-template-error', type: 'error' },
    { id: 'add-to-library-success', type: 'success' },
    {
      id: 'design-available-for-print-order',
      type: 'info',
      onShow: () => {
        const $getQuote = $('<a>' + INKIVE.TranslateHelper.translate('common.get_quote') + '</a>');
        $('#toast-container').find('.toast-message:first').after($getQuote);
        $getQuote.on('click', () => {
          $('.options > button[data-action="order-print"]').trigger('click');
          $('#toast-container').find('.toast-close-button').trigger('click');
        });
      }
    },

    {
      id: 'locked-layout-image',
      type: 'warning',
      onShow: function () { this.blinkingHint($('a.btn.btn-onmenu[data-action="on_unlockImage"]')); }
    },
    {
      id: 'locked-element',
      type: 'error',
      onShow: function () { this.blinkingHint($('a.btn.btn-onmenu[data-action="on_unlockElement"]')); }
    },
    {
      id: 'template-placeholders',
      type: 'info',
      onShow: function () { this.blinkingHint($('.tool-menu li a[href="#tabImages"]').parent()); }
    },
    {
      id: 'text-edit',
      type: 'info',
      onShow: function () { this.blinkingHint($('a.btn.btn-onmenu[data-action="on_textBeginEdit"]')); }
    },
    {
      id: 'saved',
      type: 'success',
      content: function (translate) {
        const now = new Date();
        const H = now.getHours();
        const i = now.getMinutes();
        this.refreshTitle();

        return translate('advice.content.saved', {
          H: H < 10 ? '0' + H : H,
          i: i < 10 ? '0' + i : i
        });
      },
      refreshTitle: function () {
        try {
          const projectName = document.querySelector('div[data-value="project-name"] > span').textContent;
          window.original = `${window.original.split('|')[0]} | ${projectName}`;
          document.title = window.original;
        } catch (e) { }
      }
    }
  ],

  blinkingHint: function ($element) {
    const hintTime = 2000;

    $element.addClass('blink');
    $element.one('click', removeBlinkClass);
    _.delay(removeBlinkClass, hintTime);

    function removeBlinkClass () {
      $element.removeClass('blink');
    }
  },

  initialize: function (svgCanvas) {
    if (this.initialized) return;

    this.initialized = true;
    this.initEventListeners(svgCanvas);

    toastr.options = {
      debug: false,
      timeOut: 5000,
      showEasing: 'easeOutBack',
      hideEasing: 'easeInBack',
      showMethod: 'slideDown',
      hideMethod: 'slideUp',
      closeButton: true,
      newestOnTop: true,
      showDuration: 300,
      hideDuration: 300,
      extendedTimeOut: 15000,
      preventDuplicates: true,
      positionClass: INKIVE.C.IS_MOBILE ? 'mobile toast-top-center' : 'toast-top-center'
    };
  },

  initEventListeners: function (svgCanvas) {
    svgCanvas.bind('advice.show', _.bind(function (win, id, params) {
      this.show(id, params);
    }, this));
  },

  show: function (id, params) {
    if (!INKIVE.C.IS_MOBILE) {
      this.alertContainerResize();
    }

    if ($('#svgcontent').is('.order-print-active') || INKIVE.C.EDITOR_BLOCKED) {
      return;
    }
    params = params || {};
    const message = _.find(this.messages, { id: id });

    if (message) {
      const alreadyShown = _.contains(this.shown, id);
      (!alreadyShown || !message.once) && this.showMessage(message, params);
      alreadyShown || this.shown.push(id);
    }
    message || console.warn('Message ' + id + ' is not defined');
  },

  showMessage: function (message, params) {
    let moreInfo;
    const func = toastr[message.type];
    const timeOut = toastr.options.timeOut;
    const extendedTimeOut = toastr.options.extendedTimeOut;
    message = this.translateFullMessage(message, params);
    $('#toast-container').remove();

    if (_.isFunction(func)) {
      if (message.more) {
        const that = this;
        toastr.options.onclick = function () {
          that.showMoreInfo(message);
        };
        moreInfo = INKIVE.TranslateHelper.translate('advice.more_info', {
          event_name: eventName
        });
      } else {
        if (params && params.callback) {
          toastr.options.timeOut = 0;
          toastr.options.extendedTimeOut = 0;
          toastr.options.onclick = function () {
            params.callback();
          };
        } else {
          toastr.options.onclick = null;
        }
        moreInfo = '';
      }
      if (message.closeButton) {
        toastr.options.closeButton = true;
        toastr.options.tapToDismiss = false;
      }

      if (message.content) {
        _.defer(() => func(message.content + moreInfo));
        message.onShow && message.onShow.call(this);
        const toastContainer = $('#toast-container');
        toastContainer.find('.toast-message').html(message.content.replace(/\\n/g, '<br/>'));
        // const toastWidth = toastContainer.find('.toast').outerWidth();
        // const toolWidth = $('#tool-panel').outerWidth();
        // const canvasWidth = $('#canvas-panel').outerWidth();
        toastContainer.find('.toast-close-button').empty();
      }
      toastr.options.timeOut = timeOut;
      toastr.options.extendedTimeOut = extendedTimeOut;
      toastr.options.onclick = null;
      toastr.options.closeButton = true;
      toastr.options.tapToDismiss = true;
    }
  },

  translateFullMessage: function (message, params) {
    params = _.extend({ event_name: INKIVE.TranslateHelper.translate(eventName) }, params || {});
    const translate = INKIVE.TranslateHelper.translate;
    const translatedMessage = _.clone(message);
    const translationKeys = getTranslationKeys();

    _.each(translationKeys, function (key, index) {
      translatedMessage[index] && useOunTranslateFunction(index);
      translatedMessage[index] || useStaticTranslation(index, key);
    });

    return translatedMessage;

    function getTranslationKeys () {
      const translateKey = message.id.split('-').join('_');

      return {
        title: 'advice.title.' + translateKey,
        more: 'advice.more.' + translateKey,
        content: 'advice.content.' + translateKey
      };
    }

    function useOunTranslateFunction (index) {
      translatedMessage[index] = translatedMessage[index](translate);
    }

    function useStaticTranslation (index, key) {
      const trans = translate(key, params);
      if (trans !== key) translatedMessage[index] = trans;
    }
  },

  alertContainerResize: function () {
    const target = document.querySelector('body');
    const toolPanel = document.querySelector('#tool-panel');
    const observer = new MutationObserver((mutationRecord) => {
      // Will get the changes made to DOM after the toast alert is created [0].
      if (toolPanel?.classList.contains('collapsed')) {
        const toastContainer = mutationRecord[0]?.addedNodes[0]?.id && document.querySelector(`#${mutationRecord[0].addedNodes[0].id}`);

        toastContainer && toastContainer.classList.toggle('full-width');
      }
      observer.disconnect();
    });

    const config = {
      childList: true,
      subtree: false,
      attributes: true
    };

    observer.observe(target, config);
  },

  showMoreInfo: function (message) {
    const content = '<p class="advice">' + message.more + '</p>';
    const modal = INKIVE.Modal.modalWindow(content, {
      headerIcon: 'icon-info',
      headerTitle: message.title,
      buttons: [{
        title: 'Got it!',
        onClick: function () { modal.close(); }
      }]
    });
  }
}, Backbone.Events);

module.exports = RestrictionsDecorate(require('./restrictions/advice'),
  AppDecorate(require('./app/advice'), new Advice()));
